import { IGetCategoryPageRecommendation } from "api/interfaces/product-api.type";
import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { getFitmentOptionQS } from "util/vehicle/get-fitment-option-q-s";

export function getCategoryPageRecommendation(sku: string, vehicle: IVehicle) {
  if (vehicle === null) {
    return axios.get<IGetCategoryPageRecommendation>("s/get-category-page-recommendation-v2", {
      params: {
        sku,
      },
    });
  }

  const { fitmentOptions, ...selectedVehicle } = vehicle;
  const fitmentOptionQS = getFitmentOptionQS(fitmentOptions, true);
  return axios.get<IGetCategoryPageRecommendation>(`s/get-category-page-recommendation-v2?${fitmentOptionQS}`, {
    params: {
      sku,
      ...selectedVehicle,
    },
  });
}
